import * as React from "react";
import { LoginPage } from "../components";


const Login: React.FC = () => {
    return (
        <LoginPage />
    );
};

export default Login;
